import React, {Suspense, useEffect} from 'react';
import useAuthStore from "./store/useAuthStore.ts";
import AppRoutes from "./routes/AppRoutes.tsx";
import LogoLoader from "./components/LogoLoader.tsx";

const App: React.FC = () => {
  const {initializeAuth} = useAuthStore();

  useEffect(() => {
    initializeAuth().then(() => null);
  }, [initializeAuth]);

  return (
    <Suspense fallback={<LogoLoader/>}>
        <AppRoutes/>
    </Suspense>
  );
};

export default App;